import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Carousel from 'react-bootstrap/Carousel';

import slider1 from '../assets/images/slider/slider1.jpeg';
import slider2 from '../assets/images/slider/slider2.jpeg';
import slider3 from '../assets/images/slider/slider3.jpeg';

const sliderModernStyles = `
  .hero-slider-container {
    position: relative;
    border-radius: 24px;
    overflow: hidden;
    margin-bottom: 2rem;
    box-shadow: 0 12px 36px rgba(6, 53, 71, 0.18), 0 2px 6px rgba(0, 0, 0, 0.08);
    background: linear-gradient(135deg, #042533 0%, #063547 50%, #0a4b63 85%, #0bb6d7 120%);
    border: 1px solid rgba(255, 255, 255, 0.15);
  }

  .hero-slider-container::before {
    content: '';
    position: absolute;
    top: -100px;
    right: -100px;
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, rgba(11, 182, 215, 0.25) 0%, rgba(11, 182, 215, 0) 70%);
    border-radius: 50%;
    pointer-events: none;
    z-index: 1;
  }

  .hero-slide-content {
    padding: 44px 40px;
    min-height: 420px;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;
  }

  .hero-badge-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(126, 232, 250, 0.15);
    border: 1px solid rgba(126, 232, 250, 0.35);
    color: #7ee8fa;
    padding: 5px 14px;
    border-radius: 20px;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    margin-bottom: 14px;
  }

  .hero-slide-title {
    font-size: 2.35rem;
    font-weight: 800;
    color: #ffffff;
    line-height: 1.18;
    margin-bottom: 14px;
    letter-spacing: -0.5px;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }

  .hero-slide-desc {
    font-size: 1.05rem;
    color: #cbd5e1;
    line-height: 1.6;
    margin-bottom: 24px;
    max-width: 540px;
    font-weight: 400;
  }

  .hero-cta-group {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
  }

  .btn-hero-primary {
    background: linear-gradient(135deg, #0bb6d7 0%, #0284c7 100%);
    color: #ffffff !important;
    border: none;
    border-radius: 10px;
    padding: 11px 22px;
    font-size: 0.94rem;
    font-weight: 700;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    box-shadow: 0 4px 14px rgba(11, 182, 215, 0.35);
    transition: all 0.2s ease;
  }

  .btn-hero-primary:hover {
    background: linear-gradient(135deg, #38bdf8 0%, #0369a1 100%);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(11, 182, 215, 0.5);
    color: #ffffff !important;
  }

  .btn-hero-secondary {
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.25);
    color: #ffffff !important;
    border-radius: 10px;
    padding: 11px 20px;
    font-size: 0.94rem;
    font-weight: 600;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s ease;
    backdrop-filter: blur(8px);
  }

  .btn-hero-secondary:hover {
    background: rgba(255, 255, 255, 0.22);
    border-color: #7ee8fa;
    color: #7ee8fa !important;
    transform: translateY(-2px);
  }

  .hero-slide-image-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    position: relative;
  }

  .hero-slide-image {
    width: 100%;
    max-height: 340px;
    object-fit: cover;
    border-radius: 16px;
    border: 3px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
    transition: transform 0.3s ease;
  }

  .hero-slide-image:hover {
    transform: scale(1.02);
  }

  /* Embedded Search Bar in Hero */
  .hero-search-wrapper {
    background: rgba(4, 37, 51, 0.85);
    backdrop-filter: blur(12px);
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    padding: 18px 40px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    position: relative;
    z-index: 3;
  }

  .hero-search-bar {
    display: flex;
    align-items: center;
    background: #ffffff;
    border-radius: 12px;
    padding: 4px 6px 4px 18px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
    gap: 10px;
  }

  .hero-search-icon {
    color: #0bb6d7;
    font-size: 1.15rem;
    flex-shrink: 0;
  }

  .hero-search-input {
    border: none;
    outline: none;
    font-size: 1rem;
    color: #0f172a;
    font-weight: 500;
    width: 100%;
    background: transparent;
  }

  .hero-search-input::placeholder {
    color: #94a3b8;
  }

  .btn-hero-search-submit {
    background: linear-gradient(135deg, #063547 0%, #0a4b63 100%);
    color: #ffffff;
    border: none;
    border-radius: 8px;
    padding: 10px 22px;
    font-size: 0.92rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.18s ease;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
  }

  .btn-hero-search-submit:hover {
    background: linear-gradient(135deg, #0a4b63 0%, #0bb6d7 100%);
    box-shadow: 0 2px 10px rgba(11, 182, 215, 0.4);
  }

  .hero-topic-chips {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    font-size: 0.82rem;
    color: #cbd5e1;
  }

  .hero-topic-chip {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: #e2e8f0;
    padding: 3px 10px;
    border-radius: 14px;
    cursor: pointer;
    transition: all 0.15s ease;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .hero-topic-chip:hover {
    background: #0bb6d7;
    border-color: #0bb6d7;
    color: #042533;
    font-weight: 700;
  }

  @media (max-width: 992px) {
    .hero-slide-content {
      padding: 30px 24px;
      min-height: auto;
    }
    .hero-slide-title {
      font-size: 1.75rem;
    }
    .hero-slide-desc {
      font-size: 0.95rem;
    }
    .hero-search-wrapper {
      padding: 16px 20px;
    }
    .hero-slide-image {
      max-height: 240px;
      margin-top: 16px;
    }
  }

  @media (max-width: 576px) {
    .hero-slider-container {
      border-radius: 16px;
    }
    .hero-slide-title {
      font-size: 1.45rem;
    }
    .hero-search-bar {
      flex-direction: column;
      align-items: stretch;
      padding: 8px 12px;
    }
    .btn-hero-search-submit {
      width: 100%;
      justify-content: center;
      margin-top: 6px;
    }
  }
`;

export default function MainSliderCarosel() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    } else {
      navigate('/search');
    }
  };

  const handleTopicClick = (topic) => {
    navigate(`/search?topic=BookCategory&q=${encodeURIComponent(topic)}`);
  };

  return (
    <div>
      <style>{sliderModernStyles}</style>

      <section className="hero-slider-container">
        <Carousel pause="hover" fade interval={6000} indicators={true} controls={false}>
          {/* Slide 1: General Theology & Physical Collection */}
          <Carousel.Item>
            <div className="hero-slide-content">
              <div className="row align-items-center w-100 g-4">
                <div className="col-lg-7">
                  <div className="hero-badge-tag">
                    <i className="fa fa-book-open"></i>
                    <span>Premier Theological Collection</span>
                  </div>
                  <h1 className="hero-slide-title">
                    Gateway to Sacred Theology & Religious Scholarship
                  </h1>
                  <p className="hero-slide-desc">
                    Explore over 1,34,000 physical volumes, rare theological treatises, patristic writings, and contemporary reflections curated across 140+ years of institutional heritage.
                  </p>
                  <div className="hero-cta-group">
                    <Link to="/search" className="btn-hero-primary">
                      <i className="fa fa-search"></i>
                      <span>Search Catalogue</span>
                    </Link>
                    <Link to="/categories" className="btn-hero-secondary">
                      <i className="fa fa-th-large"></i>
                      <span>Explore Categories</span>
                    </Link>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="hero-slide-image-wrapper">
                    <img
                      src={slider1}
                      alt="Theological Library Collection"
                      className="hero-slide-image"
                      onError={(e) => {
                        e.target.src = "https://images.unsplash.com/photo-1521587760476-6c12a4b040da?w=600&auto=format&fit=crop&q=80";
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Item>

          {/* Slide 2: VJTR Journal of Theological Reflection */}
          <Carousel.Item>
            <div className="hero-slide-content">
              <div className="row align-items-center w-100 g-4">
                <div className="col-lg-7">
                  <div className="hero-badge-tag" style={{ color: '#fed7aa', borderColor: 'rgba(254, 215, 170, 0.4)' }}>
                    <i className="fa fa-newspaper"></i>
                    <span>Scholarly Research & Serials</span>
                  </div>
                  <h1 className="hero-slide-title">
                    Vidyajyoti Journal of Theological Reflection (VJTR)
                  </h1>
                  <p className="hero-slide-desc">
                    Access decades of authoritative theological reflections, peer-reviewed articles, and research commentary published by the Vidyajyoti Faculty of Theology.
                  </p>
                  <div className="hero-cta-group">
                    <Link to="/search" className="btn-hero-primary">
                      <i className="fa fa-newspaper"></i>
                      <span>Search Journals & Articles</span>
                    </Link>
                    <Link to="/aboutus" className="btn-hero-secondary">
                      <i className="fa fa-university"></i>
                      <span>About Library Archives</span>
                    </Link>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="hero-slide-image-wrapper">
                    <img
                      src={slider2}
                      alt="Vidyajyoti Journal of Theological Reflection"
                      className="hero-slide-image"
                      onError={(e) => {
                        e.target.src = "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=600&auto=format&fit=crop&q=80";
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Item>

          {/* Slide 3: Digital Circulation & Student Quota */}
          <Carousel.Item>
            <div className="hero-slide-content">
              <div className="row align-items-center w-100 g-4">
                <div className="col-lg-7">
                  <div className="hero-badge-tag" style={{ color: '#86efac', borderColor: 'rgba(134, 239, 172, 0.4)' }}>
                    <i className="fa fa-barcode"></i>
                    <span>Automated Circulation & Quotas</span>
                  </div>
                  <h1 className="hero-slide-title">
                    Modern Circulation & Extended Research Quotas
                  </h1>
                  <p className="hero-slide-desc">
                    Enjoy fast desk barcode checkouts, generous borrowing limits (20 to 50 books based on B.Th, L.Th, D.Th & Faculty tiers), and digital account tracking.
                  </p>
                  <div className="hero-cta-group">
                    <Link to="/mybooks" className="btn-hero-primary">
                      <i className="fa fa-book-reader"></i>
                      <span>My Borrowed Books</span>
                    </Link>
                    <Link to="/myprofile" className="btn-hero-secondary">
                      <i className="fa fa-id-card"></i>
                      <span>Digital Library Pass</span>
                    </Link>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="hero-slide-image-wrapper">
                    <img
                      src={slider3}
                      alt="Modern Library Services"
                      className="hero-slide-image"
                      onError={(e) => {
                        e.target.src = "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=600&auto=format&fit=crop&q=80";
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Item>
        </Carousel>

        {/* Instant Catalogue Discovery Search Bar */}
        <div className="hero-search-wrapper">
          {/*<form onSubmit={handleSearchSubmit} className="hero-search-bar">
            <i className="fa fa-search hero-search-icon"></i>
            <input
              type="text"
              className="hero-search-input"
              placeholder="Search by title, author, subject, scripture passage, or accession number..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button type="submit" className="btn-hero-search-submit">
              <span>Find in Catalogue</span>
              <i className="fa fa-arrow-right"></i>
            </button>
          </form>*/}

          {/* Quick Category / Topic Tags */}
          {/*<div className="hero-topic-chips">
            <span style={{ fontWeight: 600, color: '#93c5fd' }}>
              <i className="fa fa-compass me-1"></i> Quick Topics:
            </span>
            <span className="hero-topic-chip" onClick={() => handleTopicClick('Biblical Studies')}>
              <i className="fa fa-book me-1"></i> Biblical Studies
            </span>
            <span className="hero-topic-chip" onClick={() => handleTopicClick('Theology')}>
              <i className="fa fa-cross me-1"></i> Systematic Theology
            </span>
            <span className="hero-topic-chip" onClick={() => handleTopicClick('Philosophy')}>
              <i className="fa fa-brain me-1"></i> Philosophy
            </span>
            <span className="hero-topic-chip" onClick={() => handleTopicClick('Church History')}>
              <i className="fa fa-landmark me-1"></i> Church History
            </span>
            <span className="hero-topic-chip" onClick={() => handleTopicClick('Ethics')}>
              <i className="fa fa-balance-scale me-1"></i> Moral Theology & Ethics
            </span>
            <span className="hero-topic-chip" onClick={() => handleTopicClick('Spirituality')}>
              <i className="fa fa-dove me-1"></i> Christian Spirituality
            </span>
          </div>*/}
        </div>
      </section>
    </div>
  );
}
